import * as moment from "moment";
export class QueryFilesPlaca {
  id: string;
  reFecha: string;
  reAnalista: string;
  reTaller: string;

  static queryFilesPlacaFromJson(obj: Object) {
    return new QueryFilesPlaca(
      obj["id"],
      moment(obj["reFecha"]).format("DD/MM/yyyy, HH:mm:ss"),
      obj["reAnalista"],
      obj["reTaller"]
    );
  }

  constructor(
    id: string,
    reFecha: string,
    reAnalista: string,
    reTaller: string
  ) {
    this.id = id;
    this.reFecha = reFecha;
    this.reAnalista = reAnalista;
    this.reTaller = reTaller;
  }
}
